import { makeStateStore } from '@playcastdotio/StateStore';
import type { IceServerCredentials } from '../modules/iceServerPrefetch';

export type BeaconResolveState = {
  status: 'idle' | 'resolved' | 'error';
  hostPeerId?: string;
  peerId?: string;
  peerToken?: string;
  iceServers?: IceServerCredentials;
  streamTitle?: string;
  errorCode?: string;
  errorMessage?: string;
  errorStage?: 'init' | 'auth' | 'resolve';
};

const initialBeaconResolveState: BeaconResolveState = {
  status: 'idle',
};

export const beaconResolveState = makeStateStore<BeaconResolveState>(initialBeaconResolveState);
